var _ellipse, _ellipse2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.24935,
    cy: 4.08333,
    rx: 2.33333,
    ry: 2.33333,
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.24935,
    cy: 4.08333,
    rx: 2.33333,
    ry: 2.33333,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.25V11.0833C1.75 9.79467 2.79467 8.75 4.08333 8.75H6.41667C7.70533 8.75 8.75 9.79467 8.75 11.0833V12.25",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.25V11.0833C1.75 9.79467 2.79467 8.75 4.08333 8.75H6.41667C7.70533 8.75 8.75 9.79467 8.75 11.0833V12.25",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 5.66699C8.91977 5.66699 8.58398 6.00278 8.58398 6.41699C8.58398 6.83121 8.91977 7.16699 9.33398 7.16699V5.66699ZM12.834 7.16699C13.2482 7.16699 13.584 6.83121 13.584 6.41699C13.584 6.00278 13.2482 5.66699 12.834 5.66699V7.16699ZM11.834 4.66699C11.834 4.25278 11.4982 3.91699 11.084 3.91699C10.6698 3.91699 10.334 4.25278 10.334 4.66699H11.834ZM10.334 8.16699C10.334 8.58121 10.6698 8.91699 11.084 8.91699C11.4982 8.91699 11.834 8.58121 11.834 8.16699H10.334ZM9.33398 7.16699H12.834V5.66699H9.33398V7.16699ZM10.334 4.66699V8.16699H11.834V4.66699H10.334Z",
    fill: "#4B465C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 5.66699C8.91977 5.66699 8.58398 6.00278 8.58398 6.41699C8.58398 6.83121 8.91977 7.16699 9.33398 7.16699V5.66699ZM12.834 7.16699C13.2482 7.16699 13.584 6.83121 13.584 6.41699C13.584 6.00278 13.2482 5.66699 12.834 5.66699V7.16699ZM11.834 4.66699C11.834 4.25278 11.4982 3.91699 11.084 3.91699C10.6698 3.91699 10.334 4.25278 10.334 4.66699H11.834ZM10.334 8.16699C10.334 8.58121 10.6698 8.91699 11.084 8.91699C11.4982 8.91699 11.834 8.58121 11.834 8.16699H10.334ZM9.33398 7.16699H12.834V5.66699H9.33398V7.16699ZM10.334 4.66699V8.16699H11.834V4.66699H10.334Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.a3aa364e9a16cb5824c0eb40ba699051.svg";
export { ForwardRef as ReactComponent };